/**
 * Encodes HTML characters in a string.
 * This function can be used as a very simple sanitizer function. It uses the .textContent attribute as a "Safe Sink".
 * more info: https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html
 * @param html string to convert
 * @returns A string with all HTML characters encoded
 */
export function encodeHtml(html: string | null): string {
    const temporaryElement = document.createElement('div');
    temporaryElement.textContent = html;
    const result = temporaryElement.innerHTML;
    temporaryElement.remove();
    return result;
}

/**
 * A tag function to automatically encode HTML in Template strings
 * see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#tagged_templates
 */
export function encodeHtmlTag(templateStrings: TemplateStringsArray, ...htmlStrings: Array<string | null>): string {
    return templateStrings.raw.reduce((accumulator, currentString, currentIndex) => {
        const htmlString = encodeHtml(htmlStrings[currentIndex - 1]);
        return accumulator + htmlString + currentString;
    });
}
